import { Navigate } from 'react-router-dom';
import { useAuth } from '../../modules/auth';
import { UserRole } from '../../utils/userMapper';

const RoleBasedRedirect = () => {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" replace />;
    }

    const userRole = user.role?.toUpperCase();

    switch (userRole) {
        case UserRole.ADMIN:
        case 'ADMIN':
            return <Navigate to="/dashboard" replace />;
        case UserRole.ORGANIZER:
        case 'ORGANIZER':
            return <Navigate to="/events" replace />;
        case UserRole.CUSTOMER:
        case 'CUSTOMER':
            return <Navigate to="/visitors" replace />;
        default:
            return <Navigate to="/401" replace />;
    }
};

export default RoleBasedRedirect;